import styled, { css } from 'styled-components';

const Content = styled.div``;

const Header = styled.div`
  padding: 8px 0;
`;

const Wrapper = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  ${({ padding }) => css`
    padding: ${padding === 'large' ? '24px' : padding === 'extLarge' ? '40px' : '16px'};
  `}
  display: flex;
  flex-direction: column;
`;

export { Content, Header, Wrapper };
